import { FeeValueShape } from './FeeValueInput';

/**
 * TCX-867 — the PATCH /users sub-keys for one fee (`royalty` / `adFee`).
 *
 * Only what changed is sent. `.type` and `.value` travel together whenever
 * either changed: the backend requires a type alongside any value, and a new
 * type re-validates the value. `.note` travels on its own when only it changed.
 *
 * Why not all three on any change: a TCX-866-migrated fee can hold a
 * non-numeric legacy value under `percent` (e.g. "$475/month"). The backend
 * validates every `.value` it RECEIVES as numeric for percent/currency, so
 * resending the untouched legacy value with a new note was refused with a 400 —
 * the franchisor could not add a note without first overwriting the fee.
 */
export function buildFeeSubmit(
  key: 'royalty' | 'adFee',
  current: FeeValueShape,
  original: FeeValueShape,
): Record<string, string> {
  const out: Record<string, string> = {};
  const typeOf = (f: FeeValueShape) => f.type ?? 'percent';
  if (
    typeOf(current) !== typeOf(original) ||
    (current.value ?? '') !== (original.value ?? '')
  ) {
    out[`${key}.type`] = typeOf(current);
    out[`${key}.value`] = current.value ?? '';
  }
  if ((current.note ?? '') !== (original.note ?? '')) {
    out[`${key}.note`] = current.note ?? '';
  }
  return out;
}
